import { LOAD_STATE } from '@/shared/types'
import { getNewsAllColumnDataApi, getNewsRecommendColumnDataApi } from '@/server'
import type { NewsColumnResponse, NewsRecommendColumnResponse } from '@/server/types'

export function logicNewsRecommendColumn() {
  const state = ref<LOAD_STATE>(LOAD_STATE.INIT)
  const columnData = ref<NewsRecommendColumnResponse[]>([])
  async function getNewsColumnData() {
    const res = await useLoadState({
      key: `资讯首页推荐栏目`,
      state,
      fn: getNewsRecommendColumnDataApi,
    })
    if (res?.data)
      columnData.value = res.data
  }

  return {
    state,
    columnData,
    getNewsColumnData,
  }
}

export interface NewsColumn extends NewsColumnResponse {
  isShow: boolean
}
export function logicNewsColumn() {
  const state = ref<LOAD_STATE>(LOAD_STATE.INIT)
  const columnData = ref<NewsColumn[]>([])
  async function getNewsColumnData() {
    const res = await useLoadState({
      key: `资讯栏目`,
      state,
      fn: getNewsAllColumnDataApi,
    })
    if (res?.data) {
      columnData.value = [
        {
          id: '' as any,
          columnSimpleName: '全部',
          sort: 0,
          isShow: true,
        },
        ...res.data.map(v => ({ ...v, isShow: true })),
      ]
    }
  }

  return {
    state,
    columnData,
    getNewsColumnData,
  }
}
